import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { SERVICES_API } from '@pro-connect/shared';

@Injectable({
  providedIn: 'root',
})
export class HomeService {
  constructor(
    @Inject(SERVICES_API)
    private readonly _servicesApi: string,
    private readonly _httpClient: HttpClient,
  ) {}
}
